import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useActions} from '../../../../utils/globalStore';

import {actions as promotionsActions} from '../../promotions/duck';

import type {RootState} from '../../..';

const storePromotionsSelector = (state: RootState) =>
  state.promotions.promotions;

export function useStorePromotions() {
  const storePromotions = useSelector(storePromotionsSelector);
  const fetchPromotions = useActions(promotionsActions.fetchPromotions);

  useEffect(() => {
    if (!storePromotions) {
      fetchPromotions();
    }
  }, [fetchPromotions, storePromotions]);

  return storePromotions || [];
}
